<template>
  <div id="app">
    <Ozon />
  </div>
</template>

<script>
import Ozon from "../../components/Ozon";

export default {
  name: 'App',
  components: {
    Ozon,
  }
}
</script>
